import { RootState } from "../index";

export const selectReviews = (state: RootState) => state.statService;
